import { render, staticRenderFns } from "./policy-table-detail.vue?vue&type=template&id=1618cbf4&scoped=true&"
import script from "./policy-table-detail.vue?vue&type=script&lang=js&"
export * from "./policy-table-detail.vue?vue&type=script&lang=js&"
import style0 from "./policy-table-detail.vue?vue&type=style&index=0&id=1618cbf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618cbf4",
  null
  
)

export default component.exports